import { QueryClient } from '@tanstack/react-query';

import QUERY_KEYS from 'services/api/queryKeys';

export type StayingGuestsFilterParams = {
  start_date: string;
  end_date: string;
  status: string;
  country?: string;
};

export const stayingGuestsQueryKeys = {
  all: [QUERY_KEYS.GET_STAYING_GUESTS] as const,
  list: (page: number, pageSize: number, filters: StayingGuestsFilterParams) =>
    [...stayingGuestsQueryKeys.all, 'list', page, pageSize, filters] as const,
  xmlValidation: (filters: StayingGuestsFilterParams) =>
    [...stayingGuestsQueryKeys.all, 'xml-validation', filters] as const
};

export function invalidateStayingGuestsReport(queryClient: QueryClient) {
  return queryClient.invalidateQueries({ queryKey: stayingGuestsQueryKeys.all });
}
